import { render, staticRenderFns } from "./LandingCards.vue?vue&type=template&id=4e2cddc4&scoped=true&"
import script from "./LandingCards.vue?vue&type=script&lang=js&"
export * from "./LandingCards.vue?vue&type=script&lang=js&"
import style0 from "./LandingCards.vue?vue&type=style&index=0&id=4e2cddc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cddc4",
  null
  
)

export default component.exports